import { Link, NavLink } from 'react-router-dom';
import { Menu, PawPrint, X } from 'lucide-react';
import { useState } from 'react';
import { useI18n } from '../lib/i18n';

export default function Nav() {
  const { language, setLanguage, t } = useI18n();
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);
  return (
    <header className="site-header">
      <Link to="/" className="brand" onClick={close}>
        <span className="brand-mark"><PawPrint size={18} /></span>
        <span><b>Pawtrait</b><small>STUDIO</small></span>
      </Link>
      <button className="menu-toggle" onClick={() => setOpen(v => !v)} aria-label="Menu">{open ? <X /> : <Menu />}</button>
      <nav className={open ? 'nav-links open' : 'nav-links'}>
        <a href="/#portfolio" onClick={close}>{t('portfolio')}</a>
        <a href="/#pricing" onClick={close}>{t('pricing')}</a>
        <a href="/#reviews" onClick={close}>{t('reviews')}</a>
        <NavLink to="/book" onClick={close}>{t('book')}</NavLink>
        <NavLink to="/gallery" className="nav-cta" onClick={close}>{t('viewPhotos')}</NavLink>
        <button className="language-switch" onClick={() => setLanguage(language === 'en' ? 'pl' : 'en')}>{language === 'en' ? 'PL' : 'EN'}</button>
      </nav>
    </header>
  );
}
